module.exports = "/fonts/PT Root UI_Medium.woff2?3c176d751ce70caebbc80dd689ae3e12";